import classNames from 'classnames';
import { Fragment } from 'react';
import { Colon } from '~/components/Icon/Colon';
import { useCountdown } from '~/components/Util';
import styles from './Countdown.module.scss';

export type CountdownProps = {
  value?: Date;
  days?: boolean;
  hours?: boolean;
  minutes?: boolean;
  seconds?: boolean;
  className?: string;
};
export type CountdownFragment = 'days' | 'hours' | 'minutes' | 'seconds';

const unitMap: Record<CountdownFragment, string> = {
  days: 'D',
  hours: 'H',
  minutes: 'M',
  seconds: 'S',
};
export const Countdown = ({
  value,
  days = true,
  hours = true,
  minutes = true,
  seconds = true,
  className,
}: CountdownProps) => {
  const countdown = useCountdown(value);
  const visibility: Record<CountdownFragment, boolean> = {
    days,
    hours,
    minutes,
    seconds,
  };

  return (
    <div className={classNames(styles.root, className)}>
      {(Object.keys(visibility) as CountdownFragment[])
        .filter((key) => visibility[key])
        .map((key, i, arr) => {
          const last = i === arr.length - 1;
          return (
            <Fragment key={key}>
              {countdown[key].toString().padStart(2, '0')}
              {unitMap[key]}
              {!last && <Colon className={styles.colon} />}
            </Fragment>
          );
        })}
    </div>
  );
};
